export const shopping_ecommerce = [
  { char: '🛒', name: 'Shopping Cart', nameZh: '購物車', keywords: ['buy', 'ecommerce', 'shop'], hot: true },
  { char: '🛍️', name: 'Shopping Bags', nameZh: '購物袋', keywords: ['haul', 'shop', 'sale'], hot: true },
  { char: '🏷️', name: 'Price Tag', nameZh: '折扣標籤', keywords: ['sale', 'discount', 'price'], hot: true },
  { char: '💳', name: 'Credit Card', nameZh: '信用卡付款', keywords: ['pay', 'buy', 'money'] },
  { char: '💰', name: 'Money Bag', nameZh: '預算/財富', keywords: ['rich', 'money', 'budget'] },
  { char: '💸', name: 'Flying Money', nameZh: '噴錢/免運', keywords: ['spend', 'fast', 'free shipping'] },
  { char: '💹', name: 'Chart Up', nameZh: '業績增長', keywords: ['kpi', 'growth', 'data'] },
  { char: '📦', name: 'Package', nameZh: '包裹物流', keywords: ['delivery', 'unboxing', 'ship'], hot: true },
  { char: '🚚', name: 'Truck', nameZh: '快速到貨', keywords: ['delivery', 'fast', 'logistics'] },
  { char: '🎫', name: 'Ticket', nameZh: '優惠券', keywords: ['coupon', 'discount', 'event'] },
  { char: '📣', name: 'Megaphone', nameZh: '限時促銷', keywords: ['marketing', 'notice', 'loud'] },
  { char: '🎁', name: 'Gift', nameZh: '滿額贈禮', keywords: ['present', 'giveaway', 'win'] },
];